import React, { useState, useEffect } from 'react';
import { guardarCliente, getClientes, actualizarCliente, eliminarCliente } from '../../../services/ClientesService'; 

// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/Aside.css';
import '../../static/Flotante.css';
import '../../static/Busqueda.css';

function DashboardClientes() {
    const [clientes, setClientes] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [formData, setFormData] = useState({
        id: '',
        dni: '',
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        email: '',
        num_cel: ''
    });

    useEffect(() => {
        cargarLista();
    }, []);

    // LEER CLIENTES
    const cargarLista = async () => {
        setLoading(true);
        try {
            const data = await getClientes(); 
            setClientes(Array.isArray(data) ? data : []);
            setLoading(false);
        } catch (error) {
            console.error("Error cargando clientes:", error);
            setClientes([]);
            setLoading(false);
        }
    };

    // CREAR O ACTUALIZAR CLIENTE
    const handleSave = async (e) => {
        e.preventDefault();
        try {
            if (formData.id) {
                // Edición de cliente existente
                await actualizarCliente(formData);
                alert("¡Cliente actualizado con éxito!");
            } else {
                // Nuevo cliente
                await guardarCliente(formData);
                alert("¡Cliente registrado con éxito!");
            }
            closeModal();
            cargarLista();
        } catch (error) {
            alert("Error al procesar cliente: " + error.message);
        }
    };

    // ELIMINAR CLIENTE
    const handleDelete = async (id, nombres) => {
        if (window.confirm(`¿Estás seguro de que deseas eliminar al cliente ${nombres || ''}?`)) {
            try {
                await eliminarCliente(id);
                alert("Cliente eliminado correctamente.");
                cargarLista();
            } catch (error) {
                alert("Error al eliminar cliente: " + error.message);
            }
        }
    };

    // Filtro de búsqueda por DNI, nombres, apellidos o celular
    const clientesFiltrados = clientes.filter(c => 
        (c.nombres && c.nombres.toLowerCase().includes(busqueda.toLowerCase())) ||
        (c.apellidos && c.apellidos.toLowerCase().includes(busqueda.toLowerCase())) ||
        (c.dni && c.dni.toString().includes(busqueda)) ||
        (c.num_cel && c.num_cel.toString().includes(busqueda))
    );

    const openModal = (cliente = null) => {
        if (cliente) {
            const partesApellidos = cliente.apellidos ? cliente.apellidos.trim().split(' ') : [];
            setFormData({
                id: cliente.id,
                dni: cliente.dni || '',
                nombres: cliente.nombres || '',
                apellido_paterno: partesApellidos[0] || '',
                apellido_materno: partesApellidos.slice(1).join(' ') || '', 
                email: cliente.email || '',
                num_cel: cliente.num_cel || ''
            });
        } else {
            setFormData({
                id: '',
                dni: '',
                nombres: '',
                apellido_paterno: '',
                apellido_materno: '',
                email: '',
                num_cel: ''
            });
        }
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    // Formatear fecha
    const formatearFecha = (fechaStr) => {
        if (!fechaStr) return 'N/A';
        try {
            const fecha = new Date(fechaStr);
            return fecha.toLocaleDateString('es-PE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch {
            return fechaStr;
        }
    };

    return (
        <section className="main__content">
            <div className="table-container">
                <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '20px', flexWrap: 'wrap' }}>
                    <h2>GESTIÓN DE CLIENTES</h2>
                    
                    <div className="search-container" style={{ position: 'relative', flex: '1', minWidth: '260px', maxWidth: '420px' }}>
                        <i className="fa fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }}></i>
                        <input 
                            type="text"
                            className="search-input"
                            placeholder="Buscar por DNI, nombres, apellidos o celular..."
                            style={{ paddingLeft: '35px', width: '100%', borderRadius: '8px', border: '1px solid #ddd', height: '40px' }}
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                    </div>

                    <button type="button" className="btn-vender-sidebar" onClick={() => openModal()}>
                        <i className="fa fa-plus"></i> Registrar Nuevo Cliente
                    </button>
                </div>

                <div className="table-responsive">
                    <table className="novatech-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>DNI</th>
                                <th>Nombres</th>
                                <th>Apellidos</th>
                                <th>Celular</th> 
                                <th>Email</th>
                                <th>Registro</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                        <i className="fas fa-spinner fa-spin me-2"></i> Cargando clientes...
                                    </td>
                                </tr>
                            ) : clientesFiltrados.length > 0 ? (
                                clientesFiltrados.map((c) => (
                                    <tr key={c.id}>
                                        <td>#{c.id}</td>
                                        <td style={{ fontWeight: '600' }}>{c.dni}</td>
                                        <td>{c.nombres}</td>
                                        <td>{c.apellidos}</td>
                                        <td>{c.num_cel || <span style={{ color: '#999' }}>N/A</span>}</td>
                                        <td>{c.email || <span style={{ color: '#999' }}>N/A</span>}</td>
                                        <td>{formatearFecha(c.fecha_registro)}</td>
                                        <td className="actions-cell">
                                            {/* Botón Editar */}
                                            <button className="btn-edit" onClick={() => openModal(c)} title="Editar Cliente">
                                                <i className="fa fa-edit"></i>
                                            </button>
                                            {/* Botón Eliminar */}
                                            <button className="btn-delete" onClick={() => handleDelete(c.id, c.nombres)} title="Eliminar Cliente">
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                        {busqueda ? `No se encontraron clientes con "${busqueda}"` : 'No hay clientes registrados aún.'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {isModalOpen && (
                <div className="modal" style={{ display: 'flex' }}>
                    <div className="modal-content" style={{ maxWidth: '520px', width: '90%' }}>
                        <form onSubmit={handleSave}>
                            <h2>{formData.id ? "EDITAR CLIENTE" : "REGISTRAR CLIENTE"}</h2>
                            
                            <div className="form-group">
                                <label>DNI del Cliente *</label>
                                <input 
                                    type="text" 
                                    maxLength={15}
                                    value={formData.dni} 
                                    required 
                                    placeholder="Ingresa el DNI o documento"
                                    onChange={(e) => setFormData({...formData, dni: e.target.value.replace(/\D/g, '')})} 
                                />
                            </div>

                            <div className="form-group">
                                <label>Nombres *</label>
                                <input 
                                    type="text" 
                                    value={formData.nombres} 
                                    required 
                                    placeholder="Nombres del cliente" 
                                    onChange={(e) => setFormData({...formData, nombres: e.target.value})}
                                />
                            </div>

                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label>Apellido Paterno *</label>
                                    <input 
                                        type="text" 
                                        value={formData.apellido_paterno} 
                                        required 
                                        placeholder="Apellido paterno" 
                                        onChange={(e) => setFormData({...formData, apellido_paterno: e.target.value})}
                                    />
                                </div>
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label>Apellido Materno (Opcional)</label>
                                    <input 
                                        type="text" 
                                        value={formData.apellido_materno} 
                                        placeholder="Apellido materno" 
                                        onChange={(e) => setFormData({...formData, apellido_materno: e.target.value})}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Número de Celular (Opcional)</label>
                                <input 
                                    type="tel" 
                                    maxLength={20} 
                                    value={formData.num_cel} 
                                    placeholder="Ej: 906145083"
                                    onChange={(e) => setFormData({...formData, num_cel: e.target.value})} 
                                />
                            </div>

                            <div className="form-group">
                                <label>Correo Electrónico (Opcional)</label>
                                <input 
                                    type="email" 
                                    value={formData.email} 
                                    onChange={(e) => setFormData({...formData, email: e.target.value})} 
                                    placeholder="cliente@ejemplo.com"
                                />
                            </div>

                            <div className="actions" style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <button type="button" className="btn-cancel" onClick={closeModal}>Cancelar</button>
                                <button 
                                    type="submit" 
                                    className="btn-save" 
                                    disabled={!formData.nombres || !formData.apellido_paterno || !formData.dni}
                                >
                                    <i className="fa fa-save me-1"></i> {formData.id ? "Actualizar Cambios" : "Guardar Cliente"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            
        </section>
    );
}

export default DashboardClientes;